export enum WorldAreas {
  EMEA = "EMEA",
  AMER = "AMER",
  APAC = "APAC",
}

export type WorldAreaTabsKeys = "HQ" | WorldAreas;
